import { useStore } from 'effector-react';
import { NotificationsProvider } from 'shared/notifier';
import { Router } from 'pages';
import { $isAuthenticated } from '../keycloak';
import { SuspenseFallback } from '../shared/suspenseFallback';
import { theme } from '../theme';
import { ErrorBoundary } from './ErrorBoundery';

import './App.css';
import { ThemeProvider } from '@mui/material';

export const App = () => {
  const isAuthenticated = useStore($isAuthenticated);

  if (!isAuthenticated) return <SuspenseFallback />;

  return (
    <ErrorBoundary>
      <ThemeProvider theme={theme}>
        <NotificationsProvider>
          <Router />
        </NotificationsProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
